import axios from 'axios'
import config from '../../config'
import { request_with_retry } from '../../helpers/request_retry'

const readRequestOptions = {
    timeout: 12000
}

const get_leave_requests = async () => {
    try {
        return await request_with_retry(() => {
            return axios.get(`${config.BACKEND_URL}/admins/leave-requests`, readRequestOptions)
        })
    } catch (error) {
        console.error('[Error | getLeaveRequests] > ', error)
        return {
            ok: false,
            error
        }
    }
}

const get_registered_leaves = (password, month) => {
    return new Promise((resolve) => {
        axios.post(`${config.BACKEND_URL}/admins/registered-leaves`, {
            password,
            month
        })
        .then((res) => resolve(res))
        .catch((error) => {
            console.error('[Error | getRegisteredLeaves] > ', error)
            resolve({
                ok: false,
                error
            })
        })
    })
}

const import_leave_requests = (leaveRequests) => {
    return new Promise((resolve) => {
        axios.post(`${config.BACKEND_URL}/admins/leave-requests/import`, {
            leaveRequests
        })
        .then((res) => resolve(res))
        .catch((error) => {
            console.error('[Error | importLeaveRequests] > ', error)
            resolve({
                ok: false,
                error
            })
        })
    })
}

const reset_leave_requests = () => {
    return new Promise((resolve) => {
        axios.post(`${config.BACKEND_URL}/admins/leave-requests/reset`)
        .then((res) => resolve(res))
        .catch((error) => {
            console.error('[Error | resetLeaveRequests] > ', error)
            resolve({
                ok: false,
                error
            })
        })
    })
}

const create_leave_request = (leaveRequest) => {
    return new Promise((resolve) => {
        axios.post(`${config.BACKEND_URL}/admins/leave-requests`, leaveRequest)
        .then((res) => resolve(res))
        .catch((error) => {
            console.error('[Error | createLeaveRequest] > ', error)
            resolve({
                ok: false,
                error
            })
        })
    })
}

/* Create an approved leave record for a selected member through the King-only endpoint. */
const create_manual_leave_request = (leaveRequest) => {
    return new Promise((resolve) => {
        axios.post(`${config.BACKEND_URL}/admins/leave-requests/manual`, leaveRequest)
        .then((res) => resolve(res))
        .catch((error) => {
            console.error('[Error | createManualLeaveRequest] > ', error)
            resolve({
                ok: false,
                error
            })
        })
    })
}

const update_leave_request_status = (leaveRequestId, status, currentUser) => {
    return new Promise((resolve) => {
        axios.put(`${config.BACKEND_URL}/admins/leave-requests/${leaveRequestId}`, {
            status,
            currentUser
        })
        .then((res) => resolve(res))
        .catch((error) => {
            console.error('[Error | updateLeaveRequestStatus] > ', error)
            resolve({
                ok: false,
                error
            })
        })
    })
}

export {
    get_leave_requests,
    get_registered_leaves,
    import_leave_requests,
    reset_leave_requests,
    create_leave_request,
    create_manual_leave_request,
    update_leave_request_status
}
